import PropTypes from 'prop-types';
import React from 'react';
import TextSection from 'components/contentBlocks/TextSection';
import { cmsTextContentProp } from 'utils/proptypes/modules/textProps';
import colors from 'config/theme/colors';
import transformTextSection from 'libs/wordpress/utils/transfromTextSection';

// Pure CMS data transformation before we send it to the "real" block!
const TextBlock = ({ content, moduleTextColor = '', columnBase = 12, columnSizes = 12, paragraphSize = 'sm', moduleAlignment = 'left' }) => {
    // Transform color data
    const ligthTheme = moduleTextColor === 'white';
    const textColor = ligthTheme ? colors.white : colors.black;

    // Transform text section data
    const transformedContent = transformTextSection(content);

    return (
        <TextSection
            moduleAlignment={moduleAlignment}
            columnBase={columnBase}
            columnSizes={columnSizes}
            paragraphSize={paragraphSize}
            textColor={textColor}
            textSections={transformedContent}
        />
    );
};

TextBlock.propTypes = {
    columnBase: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
    columnSizes: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
    content: cmsTextContentProp,
    moduleAlignment: PropTypes.oneOf(['left', 'right']),
    moduleTextColor: PropTypes.string,
    paragraphSize: PropTypes.string,
};

export default TextBlock;
